module.exports = __webpack_public_path__ + "static/media/Autodesk-dark.6f782497.webp";